export const elementsList = [
  {
    type: "recipientDropdown",
    label: "choose-recipient-text",
    nameImage: "id-card-person",
    tooltip: "choose-recipient-text-tooltip",
  },
  {
    type: "textinput",
    label: "form-field-text",
    nameImage: "form-text-item",
    tooltip: "form-field-text-tooltip",
  },
  {
    type: "numberinput",
    label: "form-field-number",
    nameImage: "form-number-item",
    tooltip: "form-field-number-tooltip",
  },
  {
    label: "form-field-email",
    type: "emailinput",
    subtype: "email",
    required: true,
    nameImage: "form-email-item",
    tooltip: "form-field-email-tooltip",
  },
  {
    label: "form-field-url",
    type: "urlinput",
    nameImage: "form-url-item",
    tooltip: "form-field-url-tooltip",
  },
  {
    type: "dateinput",
    label: "form-field-date",
    nameImage: "form-date-item",
    tooltip: "form-field-date-tooltip",
  },
  {
    type: "textarea",
    label: "form-field-textarea",
    nameImage: "form-textarea-item",
    tooltip: "form-field-textarea-tooltip",
  },
  {
    type: "multiplecheckboxes",
    label: "form-field-multiply-group",
    nameImage: "form-multi-item",
    tooltip: "form-field-multi-tooltip",
  },
  {
    type: "multipleradios",
    label: "form-field-radio",
    nameImage: "form-radio-item",
    tooltip: "form-field-radio-tooltip",
  },
  {
    type: "selectbasic",
    label: "form-field-select",
    nameImage: "form-select-item",
    tooltip: "form-field-select-tooltip",
  },
  {
    type: "textstatic",
    label: "form-field-text-static",
    nameImage: "form-static-text-item",
    tooltip: "form-field-text-static-tooltip",
  },
  {
    type: "titlestatic",
    label: "form-field-title-static",
    nameImage: "form-static-title-item",
    tooltip: "form-field-title-static-tooltip",
  },
  {
    type: "speratorstatic",
    label: "form-field-sperator-static",
    nameImage: "form-line-separator-item",
    tooltip: "form-field-sperator-static-tooltip",
  },
];

export const editFieldStructure = {
  recipientDropdown: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    required: {
      label: "attr-required",
      value: true,
      type: "checkbox",
    },
    downloadname: {
      label: "attr-download-name",
      value: false,
      type: "checkbox",
    },
    includeinemailsubject: {
      label: "attr-include-in-email-subject",
      value: false,
      type: "checkbox",
    },
    isVisibleForInbox: {
      label: "visible-in-inbox",
      value: false,
      type: "checkbox",
    },
    showMailInInbox: {
      label: "attr-show-in-inbox",
      value: true,
      type: "checkbox",
    },
    options: {
      label: "attr-options",
      value: ["form-field-multiply-group", "form-field-radio"],
      type: "options",
    },
  },
  textinput: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    required: {
      label: "attr-required",
      value: false,
      type: "checkbox",
    },
    readonly: {
      label: "attr-readonly",
      value: false,
      type: "checkbox",
    },
    tempsave: {
      label: "attr-tempsave",
      value: false,
      type: "checkbox",
    },
    display: {
      label: "attr-display",
      value: false,
      type: "checkbox",
    },
    downloadname: {
      label: "attr-download-name",
      value: false,
      type: "checkbox",
    },
    includeinemailsubject: {
      label: "attr-include-in-email-subject",
      value: false,
      type: "checkbox",
    },
    isSubject: {
      label: "make-subject",
      value: false,
      type: "checkbox",
    },
    isVisibleForInbox: {
      label: "visible-in-inbox",
      value: false,
      type: "checkbox",
    },
  },
  emailinput: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    required: {
      label: "attr-required",
      value: false,
      type: "checkbox",
    },
    readonly: {
      label: "attr-readonly",
      value: false,
      type: "checkbox",
    },
    tempsave: {
      label: "attr-tempsave",
      value: false,
      type: "checkbox",
    },
    display: {
      label: "attr-display",
      value: false,
      type: "checkbox",
    },
    downloadname: {
      label: "attr-download-name",
      value: false,
      type: "checkbox",
    },
    includeinemailsubject: {
      label: "attr-include-in-email-subject",
      value: false,
      type: "checkbox",
    },
  },
  urlinput: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    required: {
      label: "attr-required",
      value: false,
      type: "checkbox",
    },
    readonly: {
      label: "attr-readonly",
      value: false,
      type: "checkbox",
    },
    tempsave: {
      label: "attr-tempsave",
      value: false,
      type: "checkbox",
    },
    display: {
      label: "attr-display",
      value: false,
      type: "checkbox",
    },
    downloadname: {
      label: "attr-download-name",
      value: false,
      type: "checkbox",
    },
    includeinemailsubject: {
      label: "attr-include-in-email-subject",
      value: false,
      type: "checkbox",
    },
    isSubject: {
      label: "make-subject",
      value: false,
      type: "checkbox",
    },
    isVisibleForInbox: {
      label: "visible-in-inbox",
      value: false,
      type: "checkbox",
    },
  },
  textarea: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    textarea: {
      type: "textarea",
      label: "attr-start-text",
      value: "",
    },
    required: {
      label: "attr-required",
      value: false,
      type: "checkbox",
    },
    readonly: {
      label: "attr-readonly",
      value: false,
      type: "checkbox",
    },
    tempsave: {
      label: "attr-tempsave",
      value: false,
      type: "checkbox",
    },
    display: {
      label: "attr-display",
      value: false,
      type: "checkbox",
    },
    isVisibleForInbox: {
      label: "visible-in-inbox",
      value: false,
      type: "checkbox",
    },
  },
  dateinput: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    required: {
      label: "attr-required",
      value: false,
      type: "checkbox",
    },
    readonly: {
      label: "attr-readonly",
      value: false,
      type: "checkbox",
    },
    tempsave: {
      label: "attr-tempsave",
      value: false,
      type: "checkbox",
    },
    display: {
      label: "attr-display",
      value: false,
      type: "checkbox",
    },
    downloadname: {
      label: "attr-download-name",
      value: false,
      type: "checkbox",
    },
    includeinemailsubject: {
      label: "attr-include-in-email-subject",
      value: false,
      type: "checkbox",
    },
    isSubject: {
      label: "make-subject",
      value: false,
      type: "checkbox",
    },
    isVisibleForInbox: {
      label: "visible-in-inbox",
      value: false,
      type: "checkbox",
    },
  },
  numberinput: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    required: {
      label: "attr-required",
      value: false,
      type: "checkbox",
    },
    readonly: {
      label: "attr-readonly",
      value: false,
      type: "checkbox",
    },
    tempsave: {
      label: "attr-tempsave",
      value: false,
      type: "checkbox",
    },
    display: {
      label: "attr-display",
      value: false,
      type: "checkbox",
    },
    downloadname: {
      label: "attr-download-name",
      value: false,
      type: "checkbox",
    },
    includeinemailsubject: {
      label: "attr-include-in-email-subject",
      value: false,
      type: "checkbox",
    },
    isVisibleForInbox: {
      label: "visible-in-inbox",
      value: false,
      type: "checkbox",
    },
  },
  multipleradios: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    required: {
      label: "attr-required",
      value: false,
      type: "checkbox",
    },
    readonly: {
      label: "attr-readonly",
      value: false,
      type: "checkbox",
    },
    tempsave: {
      label: "attr-tempsave",
      value: false,
      type: "checkbox",
    },
    display: {
      label: "attr-display",
      value: false,
      type: "checkbox",
    },
    downloadname: {
      label: "attr-download-name",
      value: false,
      type: "checkbox",
    },
    isVisibleForInbox: {
      label: "visible-in-inbox",
      value: false,
      type: "checkbox",
    },
  },
  multiplecheckboxes: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    required: {
      label: "attr-required",
      value: false,
      type: "checkbox",
    },
    readonly: {
      label: "attr-readonly",
      value: false,
      type: "checkbox",
    },
    tempsave: {
      label: "attr-tempsave",
      value: false,
      type: "checkbox",
    },
    display: {
      label: "attr-display",
      value: false,
      type: "checkbox",
    },
    downloadname: {
      label: "attr-download-name",
      value: false,
      type: "checkbox",
    },
  },
  selectbasic: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
    required: {
      label: "attr-required",
      value: false,
      type: "checkbox",
    },
    readonly: {
      label: "attr-readonly",
      value: false,
      type: "checkbox",
    },
    tempsave: {
      label: "attr-tempsave",
      value: false,
      type: "checkbox",
    },
    display: {
      label: "attr-display",
      value: false,
      type: "checkbox",
    },
    downloadname: {
      label: "attr-download-name",
      value: false,
      type: "checkbox",
    },
  },
  textstatic: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
  },
  titlestatic: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
  },
  speratorstatic: {
    label: {
      label: "attr-label",
      value: "attr-label",
    },
    description: {
      label: "attr-helptext",
      value: "",
    },
  },
};

export const fieldStructure = {
  recipientDropdown: {
    template: "recipientDropdown",
    fields: {
      label: "choose-recipient-text",
      helptext: "",
      required: true,
      downloadname: false,
      includeinemailsubject: false,
      isVisibleForInbox: false,
      showMailInInbox: true,
      recipients: [],
      optionsValue: [
        { option: "multiple-choice", label: "form-field-multiply-group" },
        { option: "single-choice", label: "form-field-radio" },
      ],
      recipientType: "multiple-choice",
      dropdownSavedRecipients: [],
    },
  },
  textinput: {
    template: "textinput",
    fields: {
      label: "form-field-text",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
      isSubject: false,
      isVisibleForInbox: false,
    },
  },
  emailinput: {
    template: "emailinput",
    fields: {
      label: "form-field-email",
      helptext: "",
      required: true,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
    },
  },
  urlinput: {
    template: "urlinput",
    fields: {
      label: "form-field-url",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
      isSubject: false,
      isVisibleForInbox: false,
    },
  },
  textarea: {
    template: "textarea",
    fields: {
      label: "form-field-textarea",
      helptext: "",
      textarea: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      isVisibleForInbox: false,
    },
  },
  dateinput: {
    template: "dateinput",
    fields: {
      label: "form-field-date",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
      isSubject: false,
      isVisibleForInbox: false,
    },
  },
  numberinput: {
    template: "numberinput",
    fields: {
      label: "form-field-number",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      isVisibleForInbox: false,
    },
  },
  multiplecheckboxes: {
    template: "multiplecheckboxes",
    fields: {
      label: "form-field-multiply-group",
      checkboxes: ["option-1"],
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
    },
  },
  multipleradios: {
    template: "multipleradios",
    fields: {
      label: "form-field-radio",
      radios: ["option-1", "option-2"],
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      isVisibleForInbox: false,
    },
  },
  selectbasic: {
    template: "selectbasic",
    fields: {
      options: ["option-1", "option-2"],
      label: "form-field-select",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
    },
  },
  textstatic: {
    template: "textstatic",
    fields: {
      label: "form-field-text-static",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
    },
  },
  titlestatic: {
    template: "titlestatic",
    fields: {
      label: "form-field-title-static",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
    },
  },
  speratorstatic: {
    template: "speratorstatic",
    fields: {
      label: "form-field-sperator-static",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
    },
  },
};

export const defaultFieldsFormBuilder = {
  defaultName: {
    template: "textinput",
    fields: {
      label: "default-name",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
      isSubject: false,
      isVisibleForInbox: false,
    },
  },
  defaultEmail: {
    template: "emailinput",
    fields: {
      label: "default-email",
      helptext: "",
      required: true,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
    },
  },
  defaultSubject: {
    template: "textinput",
    fields: {
      label: "default-subject",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
      includeinemailsubject: false,
      isVisibleForInbox: false,
    },
  },

  defaultComment: {
    template: "textarea",
    fields: {
      label: "default-comment",
      textarea: "",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      display: false,
      downloadname: false,
    },
  },
};

export const ItemTypes = {
  ExistElement: "ExistElement",
  NewElement: "NewElement",
};
